import React from 'react';
import { Link } from 'react-router';
import SEO from '../components/SEO';
import { trackEvent } from '../components/analytics';

const NotFoundPage: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <SEO
        title="Page Not Found"
        description="The page you requested could not be found."
        noIndex
      />
      <section className="py-24 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs text-slate-500 uppercase tracking-widest mb-4">404</p>
          <h1 className="text-4xl md:text-5xl font-bold font-heading mb-6 text-white">Page Not Found</h1>
          <p className="text-slate-400 mb-10">
            The page you requested does not exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/"
              className="px-8 py-4 bg-accent text-primary font-bold rounded-xl"
            >
              Back to Home
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 border border-white/10 text-white font-bold rounded-xl hover:bg-white/5"
              onClick={() => trackEvent('generate_lead', { form_id: 'not_found_contact_support' })}
            >
              Contact Support
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFoundPage;
